import { render, staticRenderFns } from "./orders.vue?vue&type=template&id=79514380&"
import script from "./orders.vue?vue&type=script&lang=js&"
export * from "./orders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports